import Filter from './Filter'

export default class AllExams extends Filter {
    filterComponent = import('@/views/components/filters/compoents/AllExamsFilterComponent.vue')

    static DC_TYPE = 'dc_type'

    static DIRECTION = 'direction_id'

    static IS_ACCEPTED = 'is_accepted'

    static IS_CERTIFICATE = 'is_certificate'

    static ORGANIZATION = 'organization_id'

    static PERIOD = 'period_id'

    static QUARTER = 'quarter_id'

    fields = {
      [AllExams.DC_TYPE]: {
        label: 'Dc Type',
      },
      [AllExams.ORGANIZATION]: {
        label: 'Universities',
      },
      [AllExams.DIRECTION]: {
        label: 'Direction',
      },
      [AllExams.PERIOD]: {
        label: 'Period',
      },
      [AllExams.QUARTER]: {
        label: 'Quarter',
      },
      [AllExams.IS_ACCEPTED]: {
        label: 'Status',
      },
      [AllExams.IS_CERTIFICATE]: {
        label: 'Is certificate',
      },
    }
}
